import type React from 'react';

import { Rectangle, SkeletonContainer } from '#src/app/pages/starterDashboardV2/shared/components';

export const PosterPreviewLoading: React.FC = () => {
	return (
		<SkeletonContainer
			loading
			className="bg-background-base flex h-[175px] w-[131px] flex-col items-center justify-center gap-3 rounded"
		>
			<Rectangle className="h-[52px] w-[92px] rounded" />
			<div className="flex flex-col items-center justify-center gap-1">
				<Rectangle className="h-[13px] w-[97px]" />
				<Rectangle className="h-[13px] w-[109px]" />
			</div>
			<Rectangle className="h-[26px] w-[25px]" />
		</SkeletonContainer>
	);
};
